import { createSelector } from '@reduxjs/toolkit';
import { ANALYTICS_USERS_BY_TYPE } from '@fttb/common';
import { getHeadingTitle } from "../blocks/heading/selectors";
import { getUserType } from "../shared/selectors";
export var selectCommonAnalyticsData = createSelector([getHeadingTitle, getUserType], function (title, userType) {
  var pagePath = typeof window !== 'undefined' ? window.location.pathname : '';
  var pageUrl = typeof window !== 'undefined' ? window.location.href : '';
  return {
    page_title: title,
    page_path: pagePath,
    page_url: pageUrl,
    account_type: ANALYTICS_USERS_BY_TYPE[userType]
  };
});